<div>
  <ap-dropdown
    [list]="transactionTypeItems()"
    [title]="'portfolio.filterTransactionType' | translate"
    selectType="single"
    [(ngModel)]="selectedTransactionType">
    @for (item of transactionTypeItems(); track $index) {
      <ap-dropdown-list-item
        [item]="item"
        (onSelectItem)="onSelectItem($event)">
      </ap-dropdown-list-item>
    }
  </ap-dropdown>
</div>
